


const SubscriptionFooter = () => {
  return (
    <div className="text-center mt-12 text-sm text-muted-foreground">
      <p>All plans include secure payment processing.</p>
      <p>Cancel anytime. No hidden fees.</p>
    </div>
  );
};

export default SubscriptionFooter;
